import { Component, Input, OnInit } from '@angular/core';
import { AgentModel } from 'src/app/core/clients/generated/client';
import { PlanningDeskGeneralInfoFormGroup } from '../../models/planning-desk.model';

@Component({
  selector: 'app-general-info-step',
  templateUrl: './general-info-step.component.html'
})
export class GeneralInfoStepComponent implements OnInit {
  @Input() parentForm?: PlanningDeskGeneralInfoFormGroup;
  @Input() advisorList?: AgentModel[];
  @Input() isFullFinancialPlan = false;
  minStartDate = new Date();

  constructor () { }

  ngOnInit(): void {
    // init. minStartdate to 2 days from Now for the date picker
    this.minStartDate.setDate(this.minStartDate.getDate() + 2);
    this.parentForm?.controls.nextAppointmentDate.setValue(this.minStartDate);
  }
}
